import API from '.';
export default {
    getButtons: (params) => {
        return API.get('/tasks/settings/list', {
            params
        });
    },

    sendResult: (data) => {
        return API.post(`/tasks/settings/update`, data)
    }
}